import { render, staticRenderFns } from "./advertisePromotion.vue?vue&type=template&id=4f53c172&scoped=true&"
import script from "./advertisePromotion.vue?vue&type=script&lang=js&"
export * from "./advertisePromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f53c172",
  null
  
)

export default component.exports